const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const GiftLucky = () => import(/* webpackChunkName: "gift" */ '@/modules/gift/view/lucky.vue');
const GiftSetting = () => import(/* webpackChunkName: "gift" */ '@/modules/gift/view/setting.vue');

export const ROUTE_NAME_GIFT = {
    LUCKY: 'GiftLucky',
    SETTING: 'GiftSetting'
} as const;

export default [
    {
        path: '/app/:appId/gift',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'lucky',
                name: ROUTE_NAME_GIFT.LUCKY,
                component: GiftLucky,
                meta: { requiresAuth: true }
            },
            {
                path: 'setting',
                name: ROUTE_NAME_GIFT.SETTING,
                component: GiftSetting,
                meta: { requiresAuth: true }
            }
        ]
    }
];
